module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Douglas Laycock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("   "), _c('B', [_vm._v("Douglas Laycock")]), _vm._v(" is Robert E. Scott Distinguished Professor of Law and professor of religious studies at the University of Virginia. In addition to his work as a lawyer, he has written for the "), _c('I', [_vm._v("New York Times")]), _vm._v(", the "), _c('I', [_vm._v("Washington Post")]), _vm._v(", and numerous other publications. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/j0YJiz/tc-custom/9781467451376.jpg?1730407466428",
      "alt": "This image is the cover for the book Religious Liberty, Volume 5, Emory University Studies in Law and Religion (EUSLR)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Religious Liberty, Volume 5, Emory University Studies in Law and Religion (EUSLR)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("One of the most respected and influential scholars of religious liberty in our time, Douglas Laycock has argued many crucial religious-liberty cases in the United States Supreme Court. His noteworthy scholarly and popular writings are being collected in five comprehensive volumes under the title "), _c('i', [_vm._v("Religious Liberty.")])]), _c('p', [_vm._v("In this final volume Laycock documents the use of the Constitu­tion’s Free Speech Clause and Establishment Clause in legal briefs, scholarly and popular articles, House testimonies, and written debates. These two clauses have been vitally important in religious-liberty cases concerning religious speech in schools, politics, and the workplace, government funding of religious schools and social services, and the meaning of separation of church and state.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0